import classNames from "classnames";
import { formatNumber } from "../utils";

/**
 * Matches Figma "Metric item" component.
 * @param {string} label
 * @param {number|string} value - pre-formatted or raw number; raw numbers are formatted here
 * @param {boolean} isRaw - if true, `value` is run through formatNumber; else rendered as-is (e.g. "56%")
 * @param {boolean} primary - true = the accented/selected card (border-2 border-brand-600 in Figma)
 * @param {string} icon - material icon name (matches rest of app's icon usage, e.g. "visibility", "campaign")
 */
const MetricCard = ({ label, value, isRaw = true, primary = false, icon }) => (
  <div className={classNames("ea-metric-card", { "ea-metric-card--primary": primary })}>
    {icon && (
      <span className="ea-metric-card__icon" aria-hidden="true">
        <i className="material-icons">{icon}</i>
      </span>
    )}
    <div className="ea-metric-card__body">
      <p className="ea-metric-card__label">{label}</p>
      <p className="ea-metric-card__value">{isRaw ? formatNumber(value) : value}</p>
    </div>
  </div>
);

export default MetricCard;
